// extracted by mini-css-extract-plugin
export default {"bigList":"NavbarMenu_bigList__fIOXL","listItem":"NavbarMenu_listItem__pc+ix"};